import { useParams } from 'react-router-dom';

import { AppSubscriptionSettingsPage } from '~/components/pages/AppSubscriptionSettingsPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const AppSubscriptionSettingsRoute: React.FC = () => {
  const { appId } = useParams();

  if (!appId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate appId={appId}>
      <AppSubscriptionSettingsPage appId={appId} />
    </DashboardTemplate>
  );
};
